import { useSelector } from 'react-redux';
import { IApplicationState } from '../../../state';

interface IAccountGuardExpansionEnabled {
  isAccountGuardExpansionEnabled: boolean;
}

const useAccountGuardExpansionUrl = (): IAccountGuardExpansionEnabled => {
  const featureFlags = useSelector((state: IApplicationState) => state.flags);
  const isAccountGuardExpansionEnabled = featureFlags.AccountGuardExpansionEnabled;
  return {
    isAccountGuardExpansionEnabled
  };
};

export default useAccountGuardExpansionUrl;
